import {Select} from 'antd'

interface Props {
    value?: string[]
    onChange?: (value) => void
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
}

export const DealIdSelector = ({value, onChange, style, disabled, placeholder}: Props) => {
    return <Select
        mode="tags"
        value={value}
        onChange={onChange}
        showSearch
        optionFilterProp="label"
        style={style}
        disabled={disabled}
        placeholder={placeholder}
        notFoundContent="Type the Deal ID and click Enter"
    />
}